import React, { useState } from 'react';

import AddIcon from 'icons/add.svg';
import { useTranslation } from 'react-i18next';

import { useUpdateProjectDocumentSdsConfigurationMutation } from 'components/hooks/projectMutations';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import CheckboxField from 'components/application/CheckboxField';
import SuccessToast from 'components/application/SuccessToast';
import Tooltip from 'components/application/Tooltip';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';
import { useBreadBoard } from 'components/contexts/Toaster';

export default function ProjectCoshhActionsBar() {
  const breadBoard = useBreadBoard();

  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const {
    isMsdsIncluded,
    isProjectIncomplete: isDisabled,
    projectId,
  } = useProjectCoshhContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectCoshh.components.ProjectCoshhActionsBar',
  });

  const { t: i18nTProjects } = useTranslation('common', {
    keyPrefix: 'projects',
  });

  const [isIncludeMsdsChecked, setIsIncludeMsdsChecked] =
    useState(isMsdsIncluded);

  const updateProjectIncludeMsdsMutation =
    useUpdateProjectDocumentSdsConfigurationMutation();

  const handleIncludeMsdsChange = (event) => {
    const newValue = event.target.checked;
    setIsIncludeMsdsChecked(newValue);

    updateProjectIncludeMsdsMutation.mutate(
      { projectId, includeMsds: newValue },
      {
        onSuccess: () => {
          breadBoard.addToast(
            <SuccessToast
              message={
                newValue ?
                  i18nT('sdsDocumentsUpdatedToast.included')
                : i18nT('sdsDocumentsUpdatedToast.excluded')
              }
              onBurnToast={breadBoard.handleBurnToast}
            />,
          );
        },
        onError: () => {
          setIsIncludeMsdsChecked(!newValue);
          breadBoard.addInedibleToast();
        },
      },
    );
  };

  const sdsCheckBoxTooltip =
    isDisabled ?
      i18nT('tooltips.includeSdsDocumentsDisabled')
    : i18nT('tooltips.includeSdsDocuments', {
        ramsDisplayName: singularRAMSName,
      });

  return (
    <div className='project__actions tw-justify-between tw-border-0 tw-border-l-1 tw-border-r-1 tw-border-t-1 tw-border-solid tw-border-grey-100 tw-bg-white'>
      <CheckboxField
        checked={isIncludeMsdsChecked}
        className='tw-w-auto'
        disabled={isDisabled || updateProjectIncludeMsdsMutation.isLoading}
        label={i18nT('includeSdsDocuments')}
        name='includeMsds'
        onChange={handleIncludeMsdsChange}
        tooltip={sdsCheckBoxTooltip}
      />
      <div className='tooltip-parent'>
        {isDisabled && (
          <Tooltip
            placement='top'
            tooltip={i18nT('tooltips.addCoshhDisabled')}
            trigger='hover'
          />
        )}
        <OutlinedButton
          color='grey'
          disabled={isDisabled}
          href={`/projects/${projectId}/master_coshh`}
          size='sm'
        >
          <AddIcon className='-tw-ml-2' height={24} width={24} />
          <span>{i18nTProjects('coshh.addCoshh')}</span>
        </OutlinedButton>
      </div>
    </div>
  );
}
